import { planUtils } from 'utils/plan/plan.utils';

export const getIsSubReserved = (sub: Subscription, plan: Plan) => {
  const planType = planUtils.getType(plan);

  return planType === 'pro' && sub?.rcp?.rcp_type === 'reserved';
};
